function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.524968,-0.309859)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9217,0,0,2.9217,-109.639,-68.9505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.234,
    cy: 111.234,
    r: 87.528,
    style: {
      fill: "rgb(31,63,217)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.62582,0,0,1.62582,-44.6444,18.7138)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.234,
    cy: 111.234,
    r: 87.528,
    style: {
      fill: "rgb(255,127,22)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13125,0,0,1.13125,133.555,285.723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.234,
    cy: 111.234,
    r: 87.528,
    style: {
      fill: "rgb(2,219,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22621,0,0,1.22621,250.274,113.214)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.234,
    cy: 111.234,
    r: 87.528,
    style: {
      fill: "rgb(249,190,0)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpack);
export default __webpack_public_path__ + "static/media/cpack.8fa91d5dcee7582860e2587ad2d616b2.svg";
export { ForwardRef as ReactComponent };